import React from 'react';
import Style from './About.module.scss';
import SectionHeader from '../ui/SectionHeader';
import { Reveal } from '../ui/Reveal';
import { info } from '../../info/Info';
import { ArrowUpRight } from '../ui/Icons';

export default function About({ innerRef, onOpenResume }) {
    return (
        <section id="about" ref={innerRef} className={Style.section}>
            <SectionHeader request="/about" title="About" />

            <div className={Style.grid}>
                <Reveal className={Style.portraitCol}>
                    <figure className={Style.portrait}>
                        <img src={info.selfPortrait} alt={`${info.firstName} ${info.lastName}`} />
                        <span className={`${Style.tick} ${Style.tickTL}`} />
                        <span className={`${Style.tick} ${Style.tickBR}`} />
                    </figure>
                    <figcaption className={Style.caption}>
                        subject: sai_vineeth · {info.location.toLowerCase()}
                    </figcaption>
                </Reveal>

                <div className={Style.textCol}>
                    <Reveal>
                        <p className={Style.lead}>{info.about.lead}</p>
                    </Reveal>
                    {info.about.body.map((paragraph, i) => (
                        <Reveal key={i} delay={0.1 + i * 0.08}>
                            <p className={Style.body}>{paragraph}</p>
                        </Reveal>
                    ))}
                    <Reveal delay={0.25}>
                        <div className={Style.certs}>
                            {info.certifications.map((cert) => (
                                <div key={cert.label} className={Style.cert}>
                                    <img src={cert.icon} alt="" aria-hidden="true" />
                                    <span>{cert.label}</span>
                                </div>
                            ))}
                            <button
                                type="button"
                                onClick={onOpenResume}
                                className={Style.resumeBtn}
                            >
                                request resume <ArrowUpRight size={12} />
                            </button>
                        </div>
                    </Reveal>
                </div>
            </div>

            <div className={Style.skills}>
                {info.skills.map((group, i) => (
                    <Reveal key={group.group} delay={(i % 3) * 0.08}>
                        <div className={Style.skillGroup}>
                            <p className={Style.skillLabel}>
                                <span>~/</span>{group.group}
                            </p>
                            <div className={Style.skillTags}>
                                {group.items.map((skill) => (
                                    <span key={skill}>{skill}</span>
                                ))}
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
